/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

export default function ShippingDeliveryInformation() {
    return (
        <div>
            <p><strong>Our plants are packaged with care and delivered from our greenhouse to your door.</strong></p>
            <ul>
                <li>All orders over $100 ship free! <span> *$100 minimium for each shipping address</span></li>
                <li>Our standard shipping time is 2-4 business days</li>
                <li>Standard shipping is $4.99 for orders under $19.99; $8.99 for orders $20-$99.99</li>
                <li>We also offer next day shipping and Saturday delivery</li>
            </ul>
        </div>
    );
}
